import Header from "@/components/header";
import RulesConfirmation from "@/components/rules/RulesConfirmation";
import useSignUp from "@/services/auth/hooks/useSignUp";
import { SignUpVerifyPayload } from "@/services/auth/type";
import { MerchantUserInformationDto } from "@/services/merchant/type";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import {
  Button,
  Card,
  Container,
  Grid,
  LoadingOverlay,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const signUpSchema = Yup.object({
  firstName: Yup.string().required("وارد کردن نام الزامی است."),
  lastName: Yup.string()
    .nullable()
    .required("وارد کردن نام خانوادگی الزامی است."),
  password: Yup.string()
    .required("رمز عبور را وارد نمایید")
    .test("length", "رمز عبور باید حداقل 8 کاراکتر باشد.", (value) => {
      console.log(value?.length);
      return value === null || value === "" || value?.length >= 8;
    })
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    ),
  referralCode: Yup.string()
    .nullable()
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    )
    .test("length", "مقدار کد را به درستی وارد نمایید", (value) => {
      return value === null || value === "" || value?.length === 6;
    }),
});

export default function SignUpMerchantUser() {
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber } = location.state;
  const { data: merchant, isLoading: isLoadingMerchant } =
    useGetMerchantForMerchantUser(phoneNumber);
  const merchantInfo = merchant as MerchantUserInformationDto;

  const { mutate, isLoading, isSuccess } = useSignUp();

  const form = useForm<SignUpVerifyPayload>({
    validate: yupResolver(signUpSchema),
    initialValues: {
      firstName: "",
      lastName: "",
      imei: "",
      mobileNumber: phoneNumber,
      password: "",
      referralCode: "",
    },
  });

  useEffect(() => {
    form.setValues({
      firstName: merchantInfo?.firstName,
      lastName: merchantInfo?.lastName,
    });
  }, [merchantInfo]);

  useEffect(() => {
    if (isSuccess) {
      notifications.show({
        title: "عملیات موفق",
        message: "کد فعال سازی برای شما ارسال گردید",
        color: "green",
      });

      const imei = localStorage.getItem("imei");

      navigate("/auth/verification", {
        state: {
          firstName: form?.values.firstName,
          lastName: form?.values.lastName,
          imei: imei,
          mobileNumber: phoneNumber,
          password: form?.values?.password,
          isSignUp: true,
          refCode: form?.values?.referralCode,
          merchant: merchantInfo,
          merchantUserType: merchantInfo?.merchantUserType,
        },
      });
    }
  }, [isSuccess, navigate]);

  const submit = () => {
    mutate({
      mobileNumber: phoneNumber,
    });
  };

  if (!location?.state) {
    navigate("/auth/login");
    return null;
  }

  return (
    <Container px="0">
      <Stack mih="100svh" px="0">
        <LoadingOverlay visible={isLoadingMerchant} />
        {/* <Text>لطفا اطلاعات خود را وارد نمایید</Text> */}
        <Header
          title="تیم"
          showBack
          route="/dashboard/teams/teamMembers"
        />
        <Container w="100%" size="md" bg="white" px="md">
          {/* <Stack justify="center" align="center" mb="md">
            <Image
              src={imageUrl}
              h={100}
              w={100}
              radius="100%"
              fit="cover"
              fallbackSrc="https://placehold.co/100x100?text=%D9%BE%D8%AF%DB%8C%DA%A9%D8%B3"
            />
          </Stack> */}
          <Stack gap="xs">
            <Title order={4}>بررسی و تأیید اطلاعات</Title>
            <Text size="sm" ta="justify">
              <Text span>لطفاً اطلاعات وارد شده توسط</Text>
              <Text fw="bold" span>
                {" "}
                {merchantInfo?.merchantTitle}{" "}
              </Text>
              <Text span>
                {" "}
                را بررسی کرده و از صحت آنها قبل از ایجاد حساب خود اطمینان حاصل
                کنید.
              </Text>
            </Text>
            <Text size="sm" ta="justify">
              <Text span>
                لطفاً توجه داشته باشید که اطلاعات وارد شده در این بخش، پس از
                رزرو نوبت توسط مشتریان، برای آنها قابل مشاهده خواهد بود. در صورت
                مغایرت با اطلاعات وارد شده، لطفاً با مدیر مجموعه تماس بگیرید.
              </Text>
            </Text>
            <Stack justify="start" flex={1}>
              <form
                onSubmit={form.onSubmit(submit)}
                name="add-customer"
                className="w-100"
                id="add-customer"
              >
                <Grid>
                  <Grid.Col span={{ base: 12 }}>
                    <TextInput
                      styles={{
                        description: {
                          fontSize: "0.8rem",
                        },
                        input: {
                          backgroundColor: "var(--mantine-color-gray-2)",
                          color: "var(--mantine-color-gray-7)",
                        },
                        error: {
                          fontSize: "0.8rem",
                        },
                      }}
                      disabled
                      readOnly
                      size="md"
                      withAsterisk
                      label="نام"
                      placeholder=""
                      {...form.getInputProps("firstName")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <TextInput
                      styles={{
                        description: {
                          fontSize: "0.8rem",
                        },
                        error: {
                          fontSize: "0.8rem",
                        },
                        input: {
                          backgroundColor: "var(--mantine-color-gray-2)",
                          color: "var(--mantine-color-gray-7)",
                        },
                      }}
                      disabled
                      readOnly
                      size="md"
                      withAsterisk
                      label="نام خانوادگی"
                      placeholder=""
                      {...form.getInputProps("lastName")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <PasswordInput
                      size="md"
                      label="کلمه عبور"
                      withAsterisk
                      styles={{
                        label: {
                          direction: "rtl",
                          textAlign: "right",
                          display: "flex",
                        },
                        root: {
                          direction: "ltr",
                        },
                        error: {
                          direction: "rtl",
                          fontSize: "0.8rem",
                        },
                      }}
                      {...form.getInputProps("password")}
                    />
                  </Grid.Col>
                </Grid>
              </form>
            </Stack>
          </Stack>
        </Container>
        <Card
          styles={{
            root: {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 10,
            },
          }}
          radius={0}
        >
          <Stack mb="md">
            <RulesConfirmation />
          </Stack>
          <Button
            type="submit"
            size="lg"
            fullWidth
            form="add-customer"
            loading={isLoading}
          >
            ثبت نام
          </Button>
        </Card>
      </Stack>
    </Container>
  );
}
